import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { Helmet } from "react-helmet";
import Header from "../../components/header";
import Footer from "../../components/footer";
import CardLeftRight from "../../components/cardleftright";
import { dataListsType } from "../../shared/type";
import AdPage from "../../components/AdPage";
import { DataLists } from "../../dataLists/DataLists";

import { HelmetSeo } from "../../components/HelmetSeo";

interface TravelSectionProps {
  travelData: dataListsType[];
  nation: string;
}

const TravelSection = ({ nation, travelData }: TravelSectionProps) => (
  <div className="w-full mb-16 px-8">
    <div className="mb-8 border-b-[1px]">
      <h5 className="uppercase text-sm font-semibold pt-2 pb-2 tracking-wider flex justify-between">
        <span>
          <b className="text-[#181818]">{nation}</b> Cultural Landscape
        </span>
        <Link
          className="font-bold text-[#c9b077]"
          to={{
            pathname: "/morepage",
            search: `?category=Travel&nation=${encodeURIComponent(
              nation,
            )}&label=${encodeURIComponent(`${nation} Cultural Landscape`)}`,
          }}
        >
          MORE{">>"}
        </Link>
      </h5>
      <span className="block w-16 h-[3px] bg-[#c9b077]"></span>
    </div>
    <div className="w-full flex flex-col gap-y-10">
      <CardLeftRight
        props={travelData.sort(() => Math.random() - 0.5).slice(0, 2)}
      />
    </div>
  </div>
);

export default function Travel() {
  const [travelData, setTravelData] = useState<{
    China: dataListsType[];
    Indonesia: dataListsType[];
    Japan: dataListsType[];
    Singapore: dataListsType[];
    Cambodia: dataListsType[];
    India: dataListsType[];
    America: dataListsType[];
    Global: dataListsType[];
    Malaysia: dataListsType[];
    Thailand: dataListsType[];
    SouthKorea: dataListsType[];
    Vietnam: dataListsType[];
    SouthAsia: dataListsType[];
    AsiaPacific: dataListsType[];
    SriLanka: dataListsType[];
    SoutheastAsia: dataListsType[];
    HongKong: dataListsType[];
    Dubai: dataListsType[];
    Fiji: dataListsType[];
    UAE: dataListsType[];
    Turkey: dataListsType[];
    Mongolia: dataListsType[];
    Bhutan: dataListsType[];
    SaudiArabia: dataListsType[];
  }>({
    China: [],
    Indonesia: [],
    Japan: [],
    Singapore: [],
    Cambodia: [],
    India: [],
    America: [],
    Global: [],
    Malaysia: [],
    Thailand: [],
    SouthKorea: [],
    Vietnam: [],
    SouthAsia: [],
    AsiaPacific: [],
    SriLanka: [],
    SoutheastAsia: [],
    HongKong: [],
    Dubai: [],
    Fiji: [],
    UAE: [],
    Turkey: [],
    Mongolia: [],
    Bhutan: [],
    SaudiArabia: [],
  });

  useEffect(() => {
    const allData = DataLists.filter((item) => item.category === "Travel");
    setTravelData({
      China: allData.filter((item) => item.nation === "China"),
      Indonesia: allData.filter((item) => item.nation === "Indonesia"),
      Japan: allData.filter((item) => item.nation === "Japan"),
      Singapore: allData.filter((item) => item.nation === "Singapore"),
      Cambodia: allData.filter((item) => item.nation === "Cambodia"),
      India: allData.filter((item) => item.nation === "India"),
      America: allData.filter((item) => item.nation === "America"),
      Global: allData.filter((item) => item.nation === "Global"),
      Malaysia: allData.filter((item) => item.nation === "Malaysia"),
      Thailand: allData.filter((item) => item.nation === "Thailand"),
      SouthKorea: allData.filter((item) => item.nation === "South Korea"),
      Vietnam: allData.filter((item) => item.nation === "Vietnam"),
      SouthAsia: allData.filter((item) => item.nation === "South Asia"),
      AsiaPacific: allData.filter((item) => item.nation === "Asia Pacific"),
      SriLanka: allData.filter((item) => item.nation === "Sri Lanka"),
      SoutheastAsia: allData.filter((item) => item.nation === "Southeast Asia"),
      HongKong: allData.filter((item) => item.nation === "Hong Kong"),
      Dubai: allData.filter((item) => item.nation === "Dubai"),
      Fiji: allData.filter((item) => item.nation === "Fiji"),
      UAE: allData.filter((item) => item.nation === "UAE"),
      Turkey: allData.filter((item) => item.nation === "Turkey"),
      Mongolia: allData.filter((item) => item.nation === "Mongolia"),
      Bhutan: allData.filter((item) => item.nation === "Bhutan"),
      SaudiArabia: allData.filter((item) => item.nation === "Saudi Arabia"),
    });
  }, []);

  return (
    <>
      <HelmetSeo
        title="Travel Asia - Explore Cultural Landscapes & Tourist Attractions"
        description="Experience the beauty of Asian travel destinations, featuring cultural landscapes, historic sites, and natural wonders in China, Japan, Indonesia and more."
        ogType="website"
      />
      {/* <Helmet>
        <title>
          Travel Asia - Explore Cultural Landscapes & Tourist Attractions
        </title>
        <meta
          name="description"
          content="Experience the beauty of Asian travel destinations, featuring cultural landscapes, historic sites, and natural wonders in China, Japan, Indonesia and more."
        />
      </Helmet> */}
      <Header />
      <AdPage />
      <div className="w-full h-full fixed top-0 left-0 -z-10 bg-white/60 bg-blend-overlay backdrop-blur-md"></div>
      <div className="w-full flex justify-center">
        <div className="flex flex-col justify-center 2xl:max-w-[1500px] max-w-[1200px] my-8">
          <h1 className="text-3xl font-extrabold px-8 pb-3">Travel</h1>
          {Object.entries(travelData).map(([nation, data]) => (
            <TravelSection key={nation} nation={nation} travelData={data} />
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
